export * from "components/AdvisedCriticalHistory/components/AdvisedCriticalHistoryTable";
